import { useQuery, useMutation } from '@tanstack/react-query';
import { checkMerchantOrBCAPI } from 'utils/API/Merchant APIs/MerchantApiCalls';
import { processCustomerEkyc, ekycOtpVerify, resentOtp } from 'utils/API/Merchant APIs/UpdatedAPIs/DMTUpdatedAPICalls';
import { globalNotifySuccess, globalNotifyError } from 'views/utilities/AlertToast';
import { handleCatchError } from 'utils/CatchHandler';

// Query Key Constants
export const QUERY_KEYS = {
    MERCHANT_STATUS: 'merchantStatus'
};

// Hook for checking Merchant/BC status
export const useCheckMerchantStatus = (agentId) => {
    return useQuery({
        queryKey: [QUERY_KEYS.MERCHANT_STATUS, agentId],
        queryFn: async () => {
            const response = await checkMerchantOrBCAPI({ agentid: agentId });
            return response?.data;
        },
        enabled: !!agentId // Only run if agentId is present
    });
};

// Hook for processing E-KYC (Step 1)
export const useProcessEkyc = (handleSuccess) => {
    return useMutation({
        mutationFn: processCustomerEkyc,
        onSuccess: (response) => {
            if (response?.data?.success) {
                globalNotifySuccess(response?.data?.message);
                if (handleSuccess) handleSuccess(response.data);
            } else if (response?.data?.ResponseCode === 2) {
                // Special case handled in UI or here?
                // UI logic was: globalNotifyError('Please resent the otp'); setKycId(...);
                // We can pass data to handleSuccess too.
                if (handleSuccess) handleSuccess(response.data);
                globalNotifyError('Please resent the otp');
            } else {
                if (response?.data?.data?.message) globalNotifyError(response?.data?.data?.message);
            }
        },
        onError: (error) => {
            console.log(error.message);
            handleCatchError(error);
        }
    });
};

// Hook for verifying OTP (Step 2)
export const useVerifyOtp = (handleSuccess) => {
    return useMutation({
        mutationFn: ekycOtpVerify,
        onSuccess: (response) => {
            if (response?.data?.success) {
                globalNotifySuccess(response?.data?.message);
                if (handleSuccess) handleSuccess(response.data);
            }
        },
        onError: (error) => {
            console.log(error.message);
            handleCatchError(error);
        }
    });
};

// Hook for resending OTP
export const useResendOtp = (handleSuccess) => {
    return useMutation({
        mutationFn: resentOtp,
        onSuccess: (response) => {
            if (response?.data?.success) {
                globalNotifySuccess(response?.data?.message);
                if (handleSuccess) handleSuccess(response.data);
            }
        },
        onError: (error) => {
            console.log(error.message);
            handleCatchError(error);
        }
    });
};
